var sections = document.querySelectorAll('[data-section-type="product-main"]');
var classes = {
  hide: "hide",
  sellingPlanSelected: "selling-plan-group-selected",
};
sections.forEach(function (section) {
  var currentVariant,
    selectedVariant,
    firstSelectedOption,
    currentSellingPlan,
    firstAvailableOrCurrentSellingPlan,
    sellingPlanSelectedOption;
  var cachedData = {};

  var form = section.querySelector("[data-product-form]");
  if (form) {
    form.addEventListener("change", function (event) {
      const target = getInputForEventTarget(event.target);

      if (target.hasAttribute("data-product-url")) {
        if (target.hasAttribute("data-option-value-id")) {
          currentVariant = getVariantData(target.id);
        }
        onVariantChange({ target: target });
      }
    });
  }

  var subscriptions = document.getElementById(
    "select-subscription-" + section.dataset.sectionId
  );
  if (subscriptions) {
    subscriptions.addEventListener("click", onSubscriptionClick);
  }

  function renderedCallback() {
    if (subscriptions) {
      autoSelectSellingPlan();
      if (isBogoVariant()) {
        currentSellingPlan = "delete";
      }
      updateURL(currentVariant, currentSellingPlan);
    } else {
      updateURL(currentVariant);
    }

    startGalleryViewer();
  }

  function isBogoVariant() {
    if (currentVariant) {
      return (
        section.className.indexOf("tag-bogo-free-" + currentVariant.id) > -1
      );
    }
  }

  function onVariantChange({ target: optionValueElement }) {
    section.dataset.requestUrl = optionValueElement.dataset.productUrl;

    updateOptions();
    updateMasterIds();

    if (currentVariant) {
      updateMedia();
      updateVariantInput();
      renderProductInfo(optionValueElement);
    }
  }
  function onInitial() {
    updateOptions();
    updateMasterIds();

    if (
      section.className.indexOf("tag-redirect-when-unavailable") > -1 &&
      currentVariant &&
      !currentVariant.available
    ) {
      var firstAvailableVariant = getFirstAvailableVariantData();
      if (firstAvailableVariant) {
        currentVariant = firstAvailableVariant;
        updateMedia();
        updateVariantInput();
        renderProductInfo();
      }
    }
    renderedCallback();
    startSectionObserver();
  }

  function updateOptions() {
    firstSelectedOption = section.querySelector(".option-group input:checked");
    sellingPlanSelectedOption = Array.from(
      section.querySelectorAll('[name="selling_plan"]'),
      function (select) {
        return parseInt(select.value);
      }
    );
  }

  function updateMasterIds() {
    if (!currentVariant) {
      if (firstSelectedOption != null) {
        currentVariant = getVariantData(firstSelectedOption.id);
      } else {
        currentVariant = getFirstAvailableVariantData();
      }
    }
    if (!currentVariant) {
      return;
    }
    section.dataset.currentVariant = currentVariant.id;

    // only set currentSellingPlan if a sellingPlanSelectedOption exists.
    currentSellingPlan = currentVariant.selling_plan_allocations.find(function (
      selling_plan_allocation
    ) {
      return (
        selling_plan_allocation.selling_plan_id === sellingPlanSelectedOption[0]
      );
    });

    if (!currentSellingPlan) {
      firstAvailableOrCurrentSellingPlan =
        currentVariant.selling_plan_allocations[0];
    } else {
      firstAvailableOrCurrentSellingPlan = currentSellingPlan;
    }
  }

  function getUrlwithNewSearchParams(URLsearchParams, action, params) {
    var searchParams = new URLSearchParams(URLsearchParams);
    if (action == "set") {
      for (var key in params) {
        searchParams.set(key, params[key]);
      }
    } else if (action == "delete") {
      searchParams.delete(params);
    }
    return searchParams;
  }

  function updateURL(variant, sellingPlan) {
    if (section.dataset.updateUrl === "false") {
      return;
    }
    if (variant === undefined) {
      return;
    }
    var searchParams = window.location.search,
      params = {};
    if (variant) {
      params["variant"] = variant.id;
    }
    if (sellingPlan) {
      if (sellingPlan == "delete") {
        searchParams = getUrlwithNewSearchParams(
          searchParams,
          "delete",
          "selling_plan"
        );
      } else {
        params["selling_plan"] = sellingPlan.selling_plan_id;
      }
    }
    searchParams = getUrlwithNewSearchParams(searchParams, "set", params);

    var baseUrl = section.dataset.url;
    if (section.dataset.requestUrl !== undefined) {
      baseUrl = section.dataset.requestUrl;
    }

    var url = baseUrl + "?" + searchParams.toString();
    window.history.replaceState({ path: url }, "", url);
  }

  function updateVariantInput() {
    var productSelect = section.querySelector("[data-product-select]");
    if (!productSelect && !currentVariant) {
      return;
    }
    productSelect.value = currentVariant.id;
  }

  function handleUpdateProductInfo(html) {
    var updateSourceFromDestination = function (id) {
      var source = html.getElementById(`${id}-${section.dataset.sectionId}`);
      var destination = section.querySelector(
        `#${id}-${section.dataset.sectionId}`
      );
      if (source && destination) {
        destination.innerHTML = source.innerHTML;
      }
    };
    updateSourceFromDestination("price");
    updateSourceFromDestination("options");
    updateSourceFromDestination("purchase-summary");
    updateSourceFromDestination("select-subscription");
    updateSourceFromDestination("product-image");
  }
  function handleSwapProduct(html) {
    document.querySelector("head title").innerHTML =
      html.querySelector("head title").innerHTML;

    var oldNode = document.querySelector("main");
    oldNode.querySelector('[data-section-type="product-main"]').remove();
    var newContent = html.querySelector("main");
    const newNodeWrapper = document.createElement("div");

    newNodeWrapper.innerHTML = newContent.outerHTML;

    newNodeWrapper.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });

    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          "form",
          `${element.form.getAttribute("id")}-${uniqueKey}`
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    setTimeout(() => oldNode.remove(), 500);
  }

  function renderProductInfo(target) {
    const productUrl = section.dataset.requestUrl || section.dataset.url;
    const shouldFetchFullPage = section.dataset.url !== productUrl;
    const params = [];

    var requestedVariantId = currentVariant.id;
    var cacheDataId = requestedVariantId;

    params.push(`variant=${requestedVariantId}`);

    if (currentSellingPlan) {
      var requestedSellingPlanId = currentSellingPlan.selling_plan_id;
      cacheDataId = requestedVariantId + "_" + requestedSellingPlanId;
      params.push(`selling_plan=${requestedSellingPlanId}`);
    }

    if (cachedData[cacheDataId]) {
      handleUpdateProductInfo(cachedData[cacheDataId]);
      return renderedCallback();
    }
    if (!shouldFetchFullPage) {
      params.push(`section_id=${section.dataset.sectionId}`);
    }
    var fetchUrl = `${productUrl}?${params.join("&")}`;

    section.classList.add("loading");

    fetch(fetchUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (responseText) {
        // prevent unnecessary ui changes from abandoned selections
        if (currentVariant.id !== requestedVariantId) {
          return;
        }
        var html = new DOMParser().parseFromString(responseText, "text/html");

        if (shouldFetchFullPage) {
          return handleSwapProduct(html);
        } else {
          cachedData[cacheDataId] = html;
          return handleUpdateProductInfo(html);
        }
      })
      .finally(function () {
        section.classList.remove("loading");
        // set focus to last clicked option value
        if (target && target.id) {
          document.querySelector(`#${target.id}`)?.focus();
        }
        return renderedCallback();
      });
  }

  function updateMedia() {
    if (!currentVariant) {
      return;
    }
    if (!currentVariant.featured_image) {
      return;
    }

    var activeImage = section.querySelector(
      "[data-product-image]:not(." + classes.hide + ")"
    );
    var inactiveImage = section.querySelector(
      '[data-product-image][data-product-image-id="' +
        currentVariant.featured_image.id +
        '"]'
    );
    if (!inactiveImage || !activeImage) {
      return;
    }
    activeImage.classList.add(classes.hide);
    inactiveImage.classList.remove(classes.hide);
  }

  function getFirstAvailableVariantData() {
    return JSON.parse(
      section.querySelector("[data-first-available-variant-json]").textContent
    );
  }

  function getSelectedVariant() {
    return JSON.parse(
      section.querySelector("[data-selected-variant]").textContent
    );
  }

  function getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }

  function getVariantData(inputId) {
    return JSON.parse(getVariantDataElement(inputId).textContent);
  }

  function getVariantDataElement(inputId) {
    return section.querySelector(
      `script[type="application/json"][data-resource="${inputId}"]`
    );
  }

  function onSubscriptionClick(event) {
    var sellingPlanAddButton = event.target.closest("[data-add-subscription]");
    var sellingPlanRemoveButton = event.target.closest(
      "[data-remove-subscription]"
    );
    if (!sellingPlanAddButton && !sellingPlanRemoveButton) {
      return;
    }
    if (sellingPlanAddButton || sellingPlanRemoveButton) {
      event.preventDefault();
      var sellingPlanGroup = subscriptions.querySelector(
        "[data-selling-plan-group]"
      );
      var sellingPlanSelect = subscriptions.querySelector(
        "[data-selling-plan-select]"
      );
      var sellingPlanId = firstAvailableOrCurrentSellingPlan.selling_plan_id;

      if (sellingPlanGroup && sellingPlanSelect) {
        if (sellingPlanRemoveButton) {
          section.removeAttribute("data-selling-plan");
          sellingPlanGroup.classList.remove(classes.sellingPlanSelected);
          sellingPlanSelect.value = "";
          sessionStorage.setItem(sellingPlanId, "removed");
          updateURL(currentVariant, "delete");
        } else if (sellingPlanAddButton) {
          section.dataset.sellingPlan = sellingPlanId;
          sellingPlanGroup.classList.add(classes.sellingPlanSelected);
          sellingPlanSelect.value = sellingPlanId;
          sessionStorage.setItem(sellingPlanId, "added");
          updateURL(currentVariant, firstAvailableOrCurrentSellingPlan);
        }
      }
    }
  }

  function autoSelectSellingPlan() {
    var params = window.location.search;
    var skipAutoSelect = false;
    if (params.includes("selling_plan")) {
      skipAutoSelect = true;
    }
    if (skipAutoSelect) {
      return;
    }
    var sellingPlanGroup = subscriptions.querySelector(
      "[data-selling-plan-group]"
    );
    var sellingPlanSelect = subscriptions.querySelector(
      "[data-selling-plan-select]"
    );
    var sellingPlanId = firstAvailableOrCurrentSellingPlan.selling_plan_id;

    if (!sellingPlanGroup || !sellingPlanSelect) {
      return;
    }
    var sellingPlanStatus = sessionStorage.getItem(sellingPlanId);
    if (sellingPlanGroup && sellingPlanStatus != "removed") {
      sellingPlanGroup.classList.add(classes.sellingPlanSelected);
      section.dataset.sellingPlan = sellingPlanId;
      sellingPlanSelect.value = sellingPlanId;

      updateOptions();
      updateMasterIds();
    }
    updateURL(currentVariant, currentSellingPlan);
  }

  let defaultImgId = null;
  const altImgClass = "alt-image-selected";

  function startGalleryViewer() {
    const galleryContainer = document.querySelector(".product-main--image");
    const thumbnails = galleryContainer.querySelectorAll(
      ".image-gallery-thumbs button"
    );
    const images = galleryContainer.querySelectorAll(
      ".image-gallery img[data-product-image-id]"
    );

    const updateFeaturedImage = (targetId) => {
      let isDefaultImgSelected = false;
      images.forEach((image) => {
        if (image.id === targetId) {
          image.style.removeProperty("display");
          image.classList.remove(classes.hide);
          if (image.id === defaultImgId) {
            isDefaultImgSelected = true;
          }
        } else {
          image.classList.add(classes.hide);
        }
      });
      if (isDefaultImgSelected) {
        galleryContainer.classList.remove(altImgClass);
      } else {
        galleryContainer.classList.add(altImgClass);
      }
    };

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", function () {
        updateFeaturedImage(thumbnail.dataset.target);
      });
    });

    // Initial setup to check which image is not hidden and set it as default
    if (defaultImgId === null) {
      images.forEach((image) => {
        if (!image.classList.contains("hide")) {
          defaultImgId = image.id;
        }
      });
    }
  }

  function startSectionObserver() {
    var observeElement = document.getElementById(
      "shopify-section-" + section.dataset.sectionId
    );
    var class_list = document.documentElement.classList;
    var no_view_class = "product-main-no-view";
    var no_view_active_class = "product-main-no-view-active";
    var no_view_observer = new window.IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var isAvailable = entry.target.querySelector("[data-available=true]");
          if (entry.isIntersecting || !isAvailable) {
            class_list.remove(no_view_active_class);
            setTimeout(function () {
              class_list.remove(no_view_class);
            }, 250);
            return;
          }
          class_list.add(no_view_class);
          setTimeout(function () {
            class_list.add(no_view_active_class);
          }, 500);
        });
      },
      {
        root: null,
        threshold: 0.1, // set offset 0.1 means trigger if at least 10% of element in viewport
      }
    );
    no_view_observer.observe(observeElement);
  }

  onInitial();
});
